import { defaultKeymap } from "@codemirror/commands";
import { bracketMatching } from "@codemirror/language";
import { searchKeymap } from "@codemirror/search";
import {
  drawSelection,
  EditorView,
  highlightSpecialChars,
  keymap,
} from "@codemirror/view";
import { highlight } from "./highlight";
import { theme } from "./theme";

export default [
  highlightSpecialChars(),
  drawSelection(),
  keymap.of([...defaultKeymap, ...searchKeymap]),
  bracketMatching(),
  highlight,
  theme,
  EditorView.lineWrapping,
  EditorView.contentAttributes.of({ tabindex: "0" }),
];
